import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

interface ServiceCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  serviceId: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
  title,
  description,
  icon,
  serviceId,
}) => {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    
    // Check if we're already on the services page
    if (window.location.pathname === '/services') {
      // If already on the page, just scroll to the element
      const element = document.getElementById(serviceId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        // If the element doesn't exist yet, first scroll to the detailed services section
        const detailedServices = document.getElementById('detailed-services');
        if (detailedServices) {
          detailedServices.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    } else {
      // Navigate to services page with hash
      navigate(`/services#${serviceId}`);
    }
  };

  return (
    <div 
      onClick={handleClick}
      className="service-card group bg-client-black/30 p-4 rounded-lg border border-client-gray/10 hover:border-client-yellow/50 transition-all transform hover:-translate-y-1 hover:shadow-glow h-full cursor-pointer"
    >
      <div className="mb-2 flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-br from-client-yellow to-client-teal text-client-black group-hover:scale-110 transition-transform">
        {icon}
      </div>
      <h3 className="text-xl font-bold mb-1">{title}</h3>
      <p className="text-client-gray mb-3">{description}</p>
      <div 
        className="inline-flex items-center text-client-yellow group-hover:text-client-teal transition-colors"
        aria-label={`Learn more about ${title} services`}
      >
        <span>View {title} Details</span>
        <svg xmlns="http://www.w3.org/2000/svg" className="ml-1 h-5 w-5 transform group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
        </svg>
      </div>
    </div>
  );
};

export default ServiceCard;